import React from 'react'
import { csrfParam, csrfToken } from '@utils/csrfToken'

interface Props {
  action: string
  method?: string
  isMultipart?: boolean
  formId?: string
  formRef?: React.Ref<HTMLFormElement>
  setDisableAction?: (_: boolean) => void
}

const Form: React.FC<Props> = ({
  action,
  method,
  children,
  isMultipart,
  formId,
  formRef,
  setDisableAction,
}) => {
  const encType = isMultipart ? 'multipart/form-data' : undefined

  const handleSubmit = () => {
    setDisableAction?.(true)
  }

  return (
    <form
      id={formId}
      ref={formRef}
      action={action}
      method="post"
      encType={encType}
      onSubmit={setDisableAction ? handleSubmit : undefined}
    >
      {method !== 'post' && <input type="hidden" name="_method" value={method} />}
      <input type="hidden" name={csrfParam()} value={csrfToken()} />
      {children}
    </form>
  )
}

Form.defaultProps = {
  method: 'post',
}

export default Form
